import Modal from "../portal/Modal";
import GrayButton from "../UI/buttonUI/GrayButton";

function SheetErrors({ errorList, closeAction }) {
  return (
    <Modal
      onClose={closeAction}
      modalWidth="sheet-container flex-center-align "
    >
      <div className="w-full px-8 m-auto">
        <h1 className="sheetHeading">There are some errors in your sheet</h1>
        <div className="overflow-y-auto max-h-[500px]">
          {errorList && errorList.length > 0 && (
            <table className="sheet-table">
              <tr className="sheetTableHeadRow">
                <th className="sheetTableTh">Row No.</th>
                <th className="sheetTableTh">Error Description</th>
              </tr>
              {errorList.map((error, index) => {
                return (
                  <tr key={index} className="sheetTableBodyTr">
                    <td className="border border-lg6 p-1.5">
                      {error.rowNumber}
                    </td>
                    <td className="border border-lg6 text-left">
                      <span className="pl-3">{error.rowError}</span>
                    </td>
                  </tr>
                );
              })}
            </table>
          )}
        </div>
        <div className="mt-8 flex justify-center ">
          <GrayButton
            btnText="Close"
            width="w-40"
            rounded="rounded-full"
            onClick={closeAction}
          />
        </div>
      </div>
    </Modal>
  );
}
export default SheetErrors;
